import { render, staticRenderFns } from "./ShopHeading.vue?vue&type=template&id=ee8702be&scoped=true&"
import script from "./ShopHeading.vue?vue&type=script&lang=js&"
export * from "./ShopHeading.vue?vue&type=script&lang=js&"
import style0 from "./ShopHeading.vue?vue&type=style&index=0&id=ee8702be&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8702be",
  null
  
)

export default component.exports